import Storage from 'react-native-storage';
import { utilities } from '@weatherbug/common';

const { PulseApi } = utilities;

const pollenUri = '/data/lifestyle/pollen/v1/forecast';
const pollenKey = 'pollen';

export class PollenProvider {
    constructor(baseUrl, authId, secret, options = { timeout: 5000 }) {
        this.options = options;

        this.pulseApi = new PulseApi(
            authId,
            secret,
            baseUrl,
            this.options.timeout
        );

        if(!window.storage) {
            window.storage  = new Storage({
                // maximum capacity, default 1000
                size: 1000,
                // Use AsyncStorage for RN, or window.localStorage for web. If not set, data would be lost after reload.
                storageBackend: window.localStorage,
                // expire time, default 30 minutes
                defaultExpires: 1000 * 900,
                // cache data in the memory. default is true.
                enableCache: true
            });
        }

        window.storage.sync[pollenKey] = this.pollenSyncer;
    }

    async pollenSyncer(params) {
        const { syncParams } = params;
        const { options, pulseApi, hmac, key, id } = syncParams;
        const queryParams = JSON.parse(params.id);
        const { resolve, reject } = params;
        let apiParams = {
            ...queryParams.stdParameters,
            latitude: queryParams.latitude,
            longitude: queryParams.longitude,
            verbose: queryParams.verbose
        };

        try {
            const response = await pulseApi.getData(pollenUri, apiParams, options.timeout, 'json', hmac);
            if (!response || !(response.r || response.result)) {
                reject('Invalid response');
            }

            const result = response.r || response.result;
            result.responseTime = Date.now();

            window.storage.save({
                key,
                id,
                data: result
            });

            resolve(result);
        } catch(error) {
            reject(error);
        }
    }

    async getPollen(latitude, longitude, stdParameters, verbose=false) {
        let storage = window.storage;
        let pulseApi = this.pulseApi;
        let options = this.options;

        const params = {
            latitude,
            longitude,
            verbose: !!verbose,
            stdParameters
        };

        const id = JSON.stringify(params);

        return await storage.load({
            key: pollenKey,
            id: id,
            autoSync: true,
            syncInBackground: false,
            syncParams: {
                pulseApi,
                options,
                hmac: true,
                key: pollenKey,
                id: id
            }
        });
    }
}
